import React from 'react';
import { useAddExerciseOptionComponent } from './useAddExerciseOptionComponent';
import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import UploadIcon from '@mui/icons-material/CloudUploadOutlined';
import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddExerciseOption.styles';
import theme from '../../../../styles/theme';
import { IExerciseOption } from '../../../../types/interfaces/exercise-option';
import { ExerciseOptionType } from '../../../../shared/constants';
import AppFormTextField from '../../../../components/designe/app-form-text-field';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../../components/designe/app-entity-avatar/AppEntityAvatar';
import { AvatarTypes } from '../../../../components/designe/app-avatar/AppAvatar';
import { uploadFilesUtils } from '../../../../utils/upload-files-utils';

interface IAddExerciseOptionProps {
  exerciseOption: IExerciseOption;
  onClose: () => void;
}

export default function AddExerciseOption(props: IAddExerciseOptionProps) {
  const { exerciseOption, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading } = useAddExerciseOptionComponent(
    onClose,
    exerciseOption,
  );
  const { classes } = useStyles(theme);

  const exerciseOptionTypeOptions = Object.values(ExerciseOptionType)?.map(
    (option) => ({
      id: option,
      name: option,
    }),
  );

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.nameKey')}
              fullWidth
              name="nameKey"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.unitKey')}
              fullWidth
              name="unitKey"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.type')}
              name="type"
              options={exerciseOptionTypeOptions}
              defaultValue={exerciseOptionTypeOptions?.find(
                (t) => t.id === formik.values.type,
              )}
              onChange={(e) => formik.setFieldValue('type', e.target.value.id)}
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.priorityOrder')}
              fullWidth
              type="number"
              name="priorityOrder"
              formik={formik}
            />
          </Grid>
          <Grid item sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="default"
                  checked={formik.values.default}
                  onChange={(e) =>
                    formik.setFieldValue('default', e.target.checked)
                  }></Checkbox>
              }
              label={t('common.default')}
            />
          </Grid>
          <Grid item sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="active"
                  checked={formik.values.active}
                  onChange={(e) =>
                    formik.setFieldValue('active', e.target.checked)
                  }></Checkbox>
              }
              label={t('common.active')}
            />
          </Grid>
        </Grid>
        <Box className={classes.addExerciseOptionButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {exerciseOption ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
